import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/auth";
import { Spinner } from "@/ui";

export default function AutoLogin() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const { userLogin, userLoginCode, userQuickLogin } = useAuth();
  const [err, setErr] = useState("");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const qt = params.get("qt");
    const code = params.get("code");
    const email = params.get("e");
    const password = params.get("p");
    if (!qt && !code && (!email || !password)) { navigate("/onboarding", { replace: true }); return; }
    (async () => {
      try {
        const acc = qt ? await userQuickLogin(qt) : code ? await userLoginCode(code) : await userLogin(email, password);
        navigate(acc.onboarding_complete ? "/home" : "/onboarding?step=tour", { replace: true });
      } catch (e) {
        setErr(e.message || "That login code didn't work.");
      }
    })();
  }, [params, userLogin, userLoginCode, userQuickLogin, navigate]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background px-6 text-foreground">
      {err ? (
        <>
          <p data-testid="autologin-error" className="text-center text-sm font-semibold">{err}</p>
          <button className="text-sm text-muted-foreground" onClick={() => navigate("/onboarding")}>Go to login</button>
        </>
      ) : (
        <>
          <Spinner className="h-8 w-8 text-foreground" />
          <p className="text-sm text-muted-foreground">Signing you in…</p>
        </>
      )}
    </div>
  );
}
